import React from "react";
import "./cover-payed.scss";
import { findRel } from "../../../shared/utils/stringUtilities";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../button/button";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { navigate } from "gatsby";
const CoverPayed = (props: ReferenciaContenido) => {
  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };
  const referenciaPlantillaContenido = props.referenciaPlantillaContenido[0];

  const raw = JSON.parse(referenciaPlantillaContenido?.descripcion?.raw);

  return (
    <div className="ap-banner">
      <div className="ap-banner-container">
        <div>
          <div className="position-relative">
            <img
              className="ap-fit_img"
              src={
                referenciaPlantillaContenido.imagenPrincipal[0]?.gatsbyImageData
              }
              alt={referenciaPlantillaContenido.imagenPrincipal[0].title}
            />

            <div className="container">
              <div className="ap-cover-acen">
                <a
                  href={referenciaPlantillaContenido.redireccionBoton}
                  target={
                    isHttp(referenciaPlantillaContenido.redireccionBoton)
                      ? "_blank"
                      : "_self"
                  }
                  rel={findRel(referenciaPlantillaContenido.redireccionBoton)}
                >
                  {referenciaPlantillaContenido.youtubeId}
                </a>
                <h1 className="ap-cover-h1 title-primary">
                  {referenciaPlantillaContenido.tituloBanner}
                </h1>
              </div>
              <div className="ap-cover-desc">
                <div className="ap-cover-desc-card">
                  <p className="ap-cover-desc-card-title-company">
                    {referenciaPlantillaContenido.tituloDescripcion}
                  </p>
                  <span className="ap-cover-desc-card-title-description">
                    {referenciaPlantillaContenido.tipoTitulo}
                  </span>
                </div>

                <Button
                  type="button"
                  text={referenciaPlantillaContenido.tituloBoton}
                  classname={`a-button secondary __mobilecolor ap-cover-desc-card-button`}
                  gtmMark={`gtmRedDeAmorSesionIniciada${normalizeTwoWords(
                    referenciaPlantillaContenido.tituloBoton
                  )}`}
                  isDisabled={false}
                  //href={referenciaPlantillaContenido.redireccionBoton}
                  onClickAction={() => {
                    navigate(referenciaPlantillaContenido.redireccionBoton);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="ap-cover-foot hide-on-mobile">
            <p>
              <strong>
                {referenciaPlantillaContenido.descripcion &&
                  raw.content[0]?.content[0]?.content[0]?.content[0]?.value}
              </strong>
              |
              <span>
                {referenciaPlantillaContenido.descripcion &&
                  raw.content[0]?.content[0]?.content[0]?.content[2]?.value}
              </span>
            </p>
            <div className="linea-logueada" />
            <span>
              {referenciaPlantillaContenido.descripcion &&
                raw.content[0]?.content[1]?.content[0]?.content[0]?.value}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CoverPayed;
